<app-header></app-header>
<div class="flex flex-1 h-full">
  <app-side-navbar *ngIf="loginDisplay"></app-side-navbar>
  <div [ngStyle]="{ width: loginDisplay ? 'calc(100% - 56px)' : '100%' }">
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer></app-footer>
